import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { SpinnerButtonComponent } from '@shared/components/spinner-button/spinner-button.component';
import { ExcelImportService } from '@app/shared/services/excel-import-service';

@Component({
  selector: 'app-excel-import-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, SpinnerButtonComponent],
  templateUrl: './excel-import-button.component.html',
  styleUrl: './excel-import-button.component.css'
})
export class ExcelImportButtonComponent {
  @Input() isProcessing$: Observable<boolean>;
  @Input() onFileImport: (file: File) => void;

  excelImportService = inject(ExcelImportService);
  onImport = (event: any) => {
    const file: File = event?.target?.files[0];
    this.onFileImport(file);
    event.target.value = "";
  }
}
